import { defineStore } from 'pinia';
import { InvestmentTrigger } from 'types/checkout';
import { ref } from 'vue';

export const useInvestmentTriggerStore = defineStore('investmentTrigger', () => {
	const investmentTrigger = ref<InvestmentTrigger | null>(null);
	const iraInvestmentTrigger = ref<InvestmentTrigger | null>(null);

	function $reset(): void {
		investmentTrigger.value = null;
		iraInvestmentTrigger.value = null;
	}

	return {
		investmentTrigger,
		iraInvestmentTrigger,
		$reset
	};
});
